export default "__VITE_ASSET__Cj6c0DGW__"